export default __webpack_public_path__ + "static/media/purple-dots.c4e3f96c.svg";